import axios from '../javascript/custom-axios'
const V1 = '/v1'
const RESOURCE_NAME = '/broadcast'

export default {
    requestStream(body) {
        return axios.post(`${V1}${RESOURCE_NAME}/requestbroadcast`, body)
    },

    getLiveStreamArchive(Page, PageSize) {
        return axios.get(`${V1}${RESOURCE_NAME}/getarchivedpost?Page=${Page}&PageSize=${PageSize}`)
    },

    getLiveStreamRequests() {
        return axios.get(`${V1}/admin/getallbroadcastrequest`);
    },

    handleLiveStreamRequest(body) {
        return axios.post(`${V1}/admin/confirmbroadcast`, body);
    },

    getCredentials() {
        return axios.post(`${V1}${RESOURCE_NAME}/createbroadcastcredentials`);
    },

    startBroadcast() {
        return axios.post(`${V1}${RESOURCE_NAME}/startBroadcast`, {});
    },

    getOnGoingBroadcasts(id) {
        return axios.get(`${V1}${RESOURCE_NAME}/getongoingbroadcasts?Id=${id}`);
    },

    sendBroadCastJoinInfo(id){
        return axios.post(`${V1}${RESOURCE_NAME}/participantLog?broadcastId=${id}`);
    },

    stopBroadcast(id){
        return axios.post(`${V1}${RESOURCE_NAME}/stopbroadcast`);
    },
}
